export const APP_ROUTES = {
  LOGIN: '/login',
  EVALUATIONS: '/',
  USERS: '/users',
};
